import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.zig = bracketIndenting({
	line: "//",
})
